<template>

    <Toast/>

    <MenuIsoGrow/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h2>Hello {{ this.profile.firstName }}</h2>
                </div>

                <div class="card p-fluid">
                    <div class="surface-card shadow-2 border-round p-4">
                        <div class="flex flex-column md:flex-row gap-4 md:align-items-center xl:px-6 pt-6">
                            <div class="shadow-2 surface-card border-round p-4 flex-1 text-center mb-6 md:mb-0">
                                <div class="mb-4">
                                    <img src="images/blocks/stats/shoes.png" width="100" height="100" class="-mt-8"/>
                                    <span class="block text-900 mb-1 text-xl font-bold">Net Worth</span>
                                    <p class="text-600 m-0 font-medium">Target : R1,000,000</p>
                                </div>
                                <div class="flex justify-content-between align-items-center">
                                    <span class="text-600">Lifetime Goal</span>
                                    <span class="text-900 font-medium">50%</span>
                                </div>
                                <div class="surface-300 mt-2 mb-3 border-round" style="height: 7px">
                                    <div class="bg-blue-500 h-full border-round w-6"></div>
                                </div>
                                <div class="flex justify-content-between align-items-center">
                                    <span class="text-900">R600,000</span>
                                    <span class="text-primary font-medium">10 years left</span>
                                </div>
                            </div>
                            <div class="shadow-2 surface-card border-round p-4 flex-1 text-center">
                                <div class="mb-4">
                                    <img src="/images/blocks/stats/hats.png" width="100" height="100" class="-mt-8"/>
                                    <span class="block text-900 mb-1 text-xl font-bold">Annual Income</span>
                                    <p class="text-600 m-0 font-medium">Target : R150,000</p>
                                </div>
                                <div class="flex justify-content-between align-items-center">
                                    <span class="text-600">Annual Goal</span>
                                    <span class="text-900 font-medium">40%</span>
                                </div>
                                <div class="surface-300 mt-2 mb-3 border-round" style="height: 7px">
                                    <div class="bg-yellow-500 h-full border-round w-4"></div>
                                </div>
                                <div class="flex justify-content-between align-items-center">
                                    <span class="text-900">R75,000</span>
                                    <span class="text-primary font-medium">2 years left</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="card p-fluid">
                    <div class="surface-card shadow-2 border-round p-4">

                        <div class="grid">
                            <div class="col-12 lg:col-4 p-3">
                                <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                                    <div class="flex align-items-center justify-content-between">
                                        <div>
                                            <span class="text-3xl text-900 font-bold">R40,000 per month</span>
                                            <p class="mt-2 mb-0 text-600 text-xl">Income</p>
                                        </div>
                                        <div>
                                            <img src="/images/blocks/illustration/stats-illustration-4.svg"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 lg:col-4 p-3">
                                <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                                    <div class="flex align-items-center justify-content-between">
                                        <div>
                                            <span class="text-3xl text-900 font-bold">R31,000 per month</span>
                                            <p class="mt-2 mb-0 text-600 text-xl">Expenses</p>
                                        </div>
                                        <div>
                                            <img src="/images/blocks/illustration/stats-illustration-5.svg"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 lg:col-4 p-3">
                                <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                                    <div class="flex align-items-center justify-content-between">
                                        <div>
                                            <span class="text-3xl text-900 font-bold">R9,000 per month</span>
                                            <p class="mt-2 mb-0 text-600 text-xl">Tax Payments</p>
                                        </div>
                                        <div>
                                            <img src="/images/blocks/illustration/stats-illustration-6.svg"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card p-fluid">
                    <div class="surface-card shadow-2 border-round p-4">

                        <div class="grid">
                            <div class="col-12 lg:col-4 p-2">
                                <div class="shadow-2 surface-card border-round p-4 h-full">
                                    <div class="flex align-items-start mb-5">
                                        <img src="/images/blocks/avatars/circle-big/avatar-m-1.png" width="56"
                                             height="56"/>
                                        <div class="ml-3">
                                            <span class="block text-900 mb-1 text-xl font-medium">Investments</span>
                                            <p class="text-600 mt-0 mb-0">Long-Term and Short-Term</p>
                                        </div>
                                    </div>
                                    <ul class="list-none p-0 m-0">
                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Retirement Annuities</span>
                                                </span>
                                                <span class="text-cyan-500 font-medium">R400,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-cyan-500 h-full"
                                                     style="width: 34%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Endowment Policies</span>
                                                </span>
                                                <span class="text-orange-500 font-medium">R50,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-orange-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Unit Trusts</span>
                                                </span>
                                                <span class="text-pink-500 font-medium">R75,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-pink-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Real Estate Portfolio</span>
                                                </span>
                                                <span class="text-green-500 font-medium">R60,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-green-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Share Portfolio</span>
                                                </span>
                                                <span class="text-indigo-500 font-medium">R180,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-indigo-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Dividend Income Portfolio</span>
                                                </span>
                                                <span class="text-yellow-500 font-medium">R340,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-yellow-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Business Portfolio</span>
                                                </span>
                                                <span class="text-blue-500 font-medium">R650,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-blue-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Crypto Portfolio</span>
                                                </span>
                                                <span class="text-gray-500 font-medium">R34,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-gray-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Motor Vehicle Portfolio</span>
                                                </span>
                                                <span class="text-purple-500 font-medium">R390,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-purple-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li>
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-bar mr-2"></i>
                                                    <span class="font-medium text-900">Other</span>
                                                </span>
                                                <span class="text-red-500 font-medium">R75,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-red-500 h-full"
                                                     style="width: 79%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                            <div class="col-12 lg:col-4 p-2">
                                <div class="shadow-2 surface-card border-round p-4 h-full">
                                    <div class="flex align-items-start mb-5">
                                        <img src="/images/blocks/avatars/circle-big/avatar-f-2.png" width="56"
                                             height="56"/>
                                        <div class="ml-3">
                                            <span class="block text-900 mb-1 text-xl font-medium">Risk Cover</span>
                                            <p class="text-600 mt-0 mb-0">Life, Disability and Dread Disease</p>
                                        </div>
                                    </div>
                                    <ul class="list-none p-0 m-0">
                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Life Cover</span>
                                        </span>
                                                <span class="text-cyan-500 font-medium">R800,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-cyan-500 h-full"
                                                     style="width: 64%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Disability Cover</span>
                                        </span>
                                                <span class="text-orange-500 font-medium">R200,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-orange-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Dread Disease Cover</span>
                                        </span>
                                                <span class="text-pink-500 font-medium">R300,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-pink-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Income Protection</span>
                                                </span>
                                                <span class="text-green-500 font-medium">R30,000 per month</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-green-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Short-Term Insurance (Vehicles)</span>
                                                </span>
                                                <span class="text-indigo-500 font-medium">R400,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-indigo-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Short-Term Insurance (Household Contents)</span>
                                                </span>
                                                <span class="text-yellow-500 font-medium">R250,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-yellow-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Funeral Cover</span>
                                                </span>
                                                <span class="text-blue-500 font-medium">R100,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-blue-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Professional Indemnity</span>
                                                </span>
                                                <span class="text-gray-500 font-medium">R2,000,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-gray-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Keyman Insurance</span>
                                                </span>
                                                <span class="text-purple-500 font-medium">R5,000,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-purple-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                                <span class="text-900 inline-flex justify-content-between align-items-center">
                                                    <i class="pi pi-chart-line mr-2"></i>
                                                    <span class="font-medium text-900">Public Liability Insurance</span>
                                                </span>
                                                <span class="text-red-500 font-medium">R5,000,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-red-500 h-full"
                                                     style="width: 75%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li>
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-line mr-2"></i>
                                            <span class="font-medium text-900">Building Insurance</span>
                                        </span>
                                                <span class="text-teal-500 font-medium">R3,000,000</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-teal-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-12 lg:col-4 p-2">
                                <div class="shadow-2 surface-card border-round p-4 h-full">
                                    <div class="flex align-items-start mb-5">
                                        <img src="/images/blocks/avatars/circle-big/avatar-m-3.png" width="56"
                                             height="56"/>
                                        <div class="ml-3">
                                            <span class="block text-900 mb-1 text-xl font-medium">Health Cover</span>
                                            <p class="text-600 mt-0 mb-0">Day-to-Day Expenses, Hospital Cover and Savings Benefit</p>
                                        </div>
                                    </div>
                                    <ul class="list-none p-0 m-0">
                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Day-To-Day Expenses</span>
                                        </span>
                                                <span class="text-cyan-500 font-medium">R40,000 annually</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-cyan-500 h-full"
                                                     style="width: 34%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Hospital Benefit</span>
                                        </span>
                                                <span class="text-orange-500 font-medium">300% of recommended rates</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-orange-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Savings Benefit</span>
                                        </span>
                                                <span class="text-pink-500 font-medium">R15,000 annually</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-pink-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Gap Cover</span>
                                        </span>
                                                <span class="text-green-500 font-medium">500% of medical aid rates</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-green-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li class="mb-5">
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Prescribed Minimum Benefits</span>
                                        </span>
                                                <span class="text-indigo-500 font-medium">15 sessions annually</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-indigo-500 h-full"
                                                     style="width: 45%; border-radius: 4px"></div>
                                            </div>
                                        </li>

                                        <li>
                                            <div class="flex justify-content-between align-items-center">
                                        <span class="text-900 inline-flex justify-content-between align-items-center">
                                            <i class="pi pi-chart-pie mr-2"></i>
                                            <span class="font-medium text-900">Mental Health Benefit</span>
                                        </span>
                                                <span class="text-yellow-500 font-medium">R25,000 annually</span>
                                            </div>
                                            <div class="surface-300 w-full mt-2"
                                                 style="height: 7px; border-radius: 4px">
                                                <div class="bg-yellow-500 h-full"
                                                     style="width: 79%; border-radius: 4px"></div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="card p-fluid">
                    <div class="surface-card shadow-2 border-round p-4">
                        <div class="grid">
                            <div class="col-12 lg:col-4 p-2">
                                <div class="shadow-2 surface-card border-round p-4 h-full">
                                    <div class="flex align-items-start">
                                        <div
                                            class="bg-blue-100 border-round inline-flex align-items-center justify-content-center"
                                            style="width: 52px; height: 52px">
                                            <img src="/images/blocks/illustration/stats-illustration-1.svg" width="38"
                                                 height="38"/>
                                        </div>
                                        <div class="ml-3 flex-1">
                                            <span class="block text-900 mb-1 text-xl font-medium">Goals</span>
                                            <p class="text-600 mt-0 mb-5 text-sm">Review of Goals Achieved This Year</p>
                                            <div class="flex align-items-center justify-content-between">
                                                <span class="text-700">In Progress</span>
                                                <span class="font-bold text-700">12/12</span>
                                            </div>
                                            <ul class="list-none p-0 m-0 flex align-content-center mt-2 gap-2">
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-blue-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-blue-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-blue-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-blue-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-blue-500"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 lg:col-4 p-2">
                                <div class="shadow-2 surface-card border-round p-4 h-full">
                                    <div class="flex align-items-start">
                                        <div
                                            class="bg-blue-100 border-round inline-flex align-items-center justify-content-center"
                                            style="width: 52px; height: 52px">
                                            <img src="/images/blocks/illustration/stats-illustration-2.svg" width="38"
                                                 height="38"/>
                                        </div>
                                        <div class="ml-3 flex-1">
                                            <span class="block text-900 mb-1 text-xl font-medium">Financial Reviews and Recommendations</span>
                                            <p class="text-600 mt-0 mb-5 text-sm">Professional Reviews and Recommendations to Ensure that You're On Track</p>
                                            <div class="flex align-items-center justify-content-between">
                                                <span class="text-700">In Progress</span>
                                                <span class="font-bold text-700">4/12</span>
                                            </div>
                                            <ul class="list-none p-0 m-0 flex align-content-center mt-2 gap-2">
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-orange-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-orange-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-gray-300"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-gray-300"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-gray-300"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 lg:col-4 p-2">
                                <div class="shadow-2 surface-card border-round p-4 h-full">
                                    <div class="flex align-items-start">
                                        <div
                                            class="bg-blue-100 border-round inline-flex align-items-center justify-content-center"
                                            style="width: 52px; height: 52px">
                                            <img src="/images/blocks/illustration/stats-illustration-3.svg" width="38"
                                                 height="38"/>
                                        </div>
                                        <div class="ml-3 flex-1">
                                            <span class="block text-900 mb-1 text-xl font-medium">Tasks</span>
                                            <p class="text-600 mt-0 mb-5 text-sm">Completed Tasks</p>
                                            <div class="flex align-items-center justify-content-between">
                                                <span class="text-700">In Progress</span>
                                                <span class="font-bold text-700">8/12</span>
                                            </div>
                                            <ul class="list-none p-0 m-0 flex align-content-center mt-2 gap-2">
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-purple-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-purple-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-purple-500"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-gray-300"></li>
                                                <li style="height: 7px; border-radius: 3px"
                                                    class="flex-1 bg-gray-300"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div>
    </div>

    <IsoGrowFooter/>

</template>

<script>
import IsoGrowFooter from "@/components/isogrow/IsoGrowFooter.vue";
import MenuIsoGrow from "@/components/isogrow/MenuIsoGrow.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import DashboardService from "@/service/DashboardService";
import AuditTrailService from "@/service/AuditTrailService";

export default {
    components: {
        MenuIsoGrow,
        IsoGrowFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;

            try {
                const [financialSummaryData, auditTrailsData] = await Promise.all([
                    DashboardService.getFinancialSummaryOverThreeMonthsForCompany(this.profile.companyId),
                    AuditTrailService.getCompanyAuditTrailsLastTwenty(this.profile.companyId)
                ]);

                this.financialSummary = financialSummaryData.data;
                this.auditTrails = auditTrailsData.data;

                this.loading = false;

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] No user data found.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
        }
    },
    data() {

        return {
            items: [
                {
                    label: 'Options',
                    items: [
                        {label: 'Add New', icon: 'pi pi-fw pi-plus'},
                        {label: 'Search', icon: 'pi pi-fw pi-search'}
                    ]
                }
            ],
            date: new Date(),
            monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            profile: {},
            financialSummary: {},
            auditTrails: null,
        }
    },
    methods: {
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        previousDate() {
            this.date.setDate(this.date.getDate() - 1);
            this.date = new Date(this.date);
        },

        nextDate() {
            this.date.setDate(this.date.getDate() + 1);
            this.date = new Date(this.date);
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
